"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalisedEnvVar = void 0;
/**
 *
 * @param possibleVars (string | undefined[]
 * @param defaultValue string
 * @returns
 */
function getLocalisedEnvVar(possibleVars = [], defaultValue) {
    const envValue = possibleVars.reduce((final, value) => {
        if (typeof value !== 'undefined') {
            return value;
        }
        return final;
    }, defaultValue);
    return envValue;
}
exports.getLocalisedEnvVar = getLocalisedEnvVar;
// /**
//  * getLocalisedEnvVar
//  *
//  * Get env var across framework
//  *
//  * @param normalEnvVar
//  * @param defaultValue
//  */
// export function getLocalisedEnvVar(normalEnvVar: string, defaultValue: string) {
//   const prefixes = ['REACT_APP_', 'NG_APP_']; // add this posible prefixes in the future if we have another framework
//   const possibleEnvVars = [normalEnvVar].concat(prefixes.map(p => `${p}${normalEnvVar}`));
//   let envValue = defaultValue;
//   _.each(possibleEnvVars, (env) => {
//     const possibleEnvValue = _.get(process.env, env);
//     if (typeof possibleEnvValue != 'undefined') {
//       envValue = possibleEnvValue;
//     }
//   })
//   console.log('getLocalisedEnvVar', process.env.REACT_APP_FALCON_ONE_API, process.env['REACT_APP_FALCON_ONE_API'])
//   return envValue;
// }
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52LWNvbmZpZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25mL2Vudi1jb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUE7Ozs7O0dBS0c7QUFDSCxTQUFnQixrQkFBa0IsQ0FBQyxlQUF1QyxFQUFFLEVBQUUsWUFBb0I7SUFDaEcsTUFBTSxRQUFRLEdBQUcsWUFBWSxDQUFDLE1BQU0sQ0FBUyxDQUFDLEtBQUssRUFBRSxLQUFLLEVBQUUsRUFBRTtRQUM1RCxJQUFJLE9BQU8sS0FBSyxLQUFLLFdBQVcsRUFBRTtZQUNoQyxPQUFPLEtBQUssQ0FBQTtTQUNiO1FBRUQsT0FBTyxLQUFLLENBQUE7SUFDZCxDQUFDLEVBQUUsWUFBWSxDQUFDLENBQUE7SUFFaEIsT0FBTyxRQUFRLENBQUM7QUFDbEIsQ0FBQztBQVZELGdEQVVDO0FBRUQsTUFBTTtBQUNOLHdCQUF3QjtBQUN4QixLQUFLO0FBQ0wsa0NBQWtDO0FBQ2xDLEtBQUs7QUFDTCx5QkFBeUI7QUFDekIseUJBQXlCO0FBQ3pCLE1BQU07QUFDTixtRkFBbUY7QUFDbkYsd0hBQXdIO0FBQ3hILDZGQUE2RjtBQUU3RixpQ0FBaUM7QUFFakMsdUNBQXVDO0FBQ3ZDLHdEQUF3RDtBQUV4RCxvREFBb0Q7QUFDcEQscUNBQXFDO0FBQ3JDLFFBQVE7QUFDUixPQUFPO0FBRVAscUhBQXFIO0FBRXJILHFCQUFxQjtBQUNyQixJQUFJIn0=